import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export const Breadcrumb = ({ items }: BreadcrumbProps) => (
  <nav className="flex items-center gap-1 text-sm text-gray-500">
    {items.map((item, i) => (
      <span key={i} className="flex items-center gap-1">
        {i > 0 && <ChevronRight className="h-3 w-3 text-gray-400" />}
        {item.href && i < items.length - 1 ? (
          <Link to={item.href} className="hover:text-primary-600 transition-colors">{item.label}</Link>
        ) : (
          <span className={i === items.length - 1 ? 'text-gray-800 font-medium' : ''}>{item.label}</span>
        )}
      </span>
    ))}
  </nav>
);
